import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-progress-ring',
    templateUrl: './progress-ring.component.html',
    styleUrls: ['./progress-ring.component.scss'],
    standalone: false
})
export class ProgressRingComponent implements OnInit {
  @Input() progress: number;
  organizationId: string;

  constructor() { }
  ngOnInit() {
    const userOrganizationId = localStorage.getItem('userOrganizationId');
    const onboardingOrganizationId = sessionStorage.getItem('onboardingOrganizationId');

    this.organizationId = userOrganizationId ?? onboardingOrganizationId;
  }

  getLink() {
   return ['organizations',this.organizationId, 'onboarding','rules-overview'];

  }
}
